/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Freeze_FailedInputs */



/**
* | output |
* | --- |
* | "The change could not be applied. Nothing was modified." |
*
* @param {Partner_Org_Freeze_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_freeze_failed = /** @type {((inputs?: Partner_Org_Freeze_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Freeze_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Änderung konnte nicht angewendet werden. Es wurde nichts geändert.")
	return /** @type {LocalizedString} */ ("The change could not be applied. Nothing was modified.")
});